import apiClient from './api';

export interface AiBalance {
  balanceUsd: number;
}

export const aiBalanceService = {
  getBalance: async (companyId: number): Promise<AiBalance> => {
    const response = await apiClient.get<AiBalance>(`/companies/${companyId}/ai-balance`);
    return response.data;
  },
};
